export default "__VITE_ASSET__C4O$15ge__"